// Too hard to untangle all the effects on this page and make them conform to this rule
/* eslint-disable react-hooks/exhaustive-deps */

import { bedbankOfferProductDetailView } from 'actions/AnalyticsActions'
import { fetchBedbankOfferById, fetchCalendarForBedbankOffer, fetchRatesForBedbankOffer } from 'actions/BedbankOfferActions'
import { fetchFlightCalendar } from 'actions/FlightActions'
import { fetchAlternativeOffers, fetchRelatedTravelItems, fetchTraderInformation, offerViewed } from 'actions/OfferActions'
import ErrorBoundary from 'components/Common/ErrorBoundary'
import HeadData from 'components/Common/HeadData'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import OfferRecommendations from 'components/Common/OfferRecommendations'
import Pane from 'components/Common/Pane'
import RedirectWithStatus from 'components/Common/RedirectWithStatus'
import Spacing from 'components/Common/Spacing'
import BedbankOfferContent from 'components/OfferPage/Bedbank/BedbankOfferContent'
import BedbankNavigableOfferContent from 'components/OfferPage/NavigableOfferContent/BedbankNavigableOfferContent'
import { BottomMobileRelatedTravelItems, TopMobileRelatedTravelItems } from 'components/OfferPage/RelatedTravelItems'
import Error404Page from 'components/Pages/Error404Page'
import Error500Page from 'components/Pages/Error500Page'
import { replace } from 'connected-react-router'
import config from 'constants/config'
import { ISO_DATE_FORMAT } from 'constants/dateFormats'
import { OFFER_TYPE_BED_BANK } from 'constants/offer'
import { urlHashDatePicker } from 'constants/url'
import OfferPageStateProvider from 'contexts/OfferPage/offerPageStateProvider'
import { OfferPageActions, OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { getPromotionDefaultPeriod } from 'lib/hotels/bedbankUtils'
import { isEnabledForFeature } from 'lib/config/featureFlagUtils'
import { ENABLED_OFFER_TYPES_RECENTLY_VIEWED } from 'lib/offer/highIntentOffers'
import { generateRoomOccupants, sumUpOccupancies } from 'lib/offer/occupancyUtils'
import { removeSearchParamsFromURL } from 'lib/search/searchUtils'
import { rem } from 'polished'
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react'
import { useInView } from 'react-intersection-observer'
import { connect } from 'react-redux'
import { RouteComponentProps, withRouter } from 'react-router'
import { getPromotionMinLos, isFlashCalendarEnabled } from 'selectors/offerPage/bedbankOfferPageSelectors'
import { getDefaultAirport, isBedbankFlightBookingEnabled } from 'selectors/flightsSelectors'
import { getInitialBedbankOfferPageState } from 'selectors/offerPage/offerPageSelectors'
import styled from 'styled-components'
import BookmarkButton from 'tripPlanner/components/Bookmark/BookmarkButton/BookmarkButton'
import ImmersiveSaveButtonPortal from 'tripPlanner/components/ImmersiveHeader/ImmersiveSaveButtonPortal'
import HotelStructuredData from './HotelStructuredData'

import * as Analytics from 'analytics/analytics'
import { track } from 'analytics/analytics'
import { accommodationOfferClicked } from 'analytics/eventDefinitions'
import { viewOfferEvent } from 'analytics/optimizely/events'
import { offerPageHotLeadEvent } from 'analytics/snowplow/events'
import { fireEcommerceGTMEvent } from 'api/googleTagManager'
import PromptCardSelector from 'components/Common/StickyPromptCard/PromptCardSelector'
import OfferTripPromotion from 'components/OfferPage/OfferTripPromotion'
import AnalyticsPageContext, { AnalyticsPage } from 'contexts/Analytics/analyticsPageContext'
import GeoContext from 'contexts/geoContext'
import useOfferPageReducer from 'hooks/OfferPage/useOfferPageReducer'
import { useSaveHotLead } from 'hooks/Recommendation/useSaveHotLead'
import BusinessTravellerStickyBudgetBar from 'businessTraveller/components/budget-bar/accommodation/BusinessTravellerStickyBudgetBar'
import zIndex from 'styles/tools/z-index'
import LayoutContainer from 'components/Common/LayoutContainer'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { getPropertyBestAlternateURL } from 'selectors/bedbankSelectors'
import useBedbankFlightPrice from 'hooks/OfferPage/useBedbankFlightPrice'
import HttpStatus from 'components/Common/HttpStatus'
import { RecommendationsFilters } from 'components/OfferList/OfferListTiles/YouMayAlsoLikeTile/Common/types'
import { OptimizelyServerSideExperiments, getOptimizelyExperimentVariation } from 'lib/optimizely/optimizelyUtils'
import OfferYmalStickyFooter from 'components/Recommendations/YouMayAlsoLike/Offer/OfferYmalStickyFooter'
import offerPageURL from 'lib/offer/offerPageURL'

const MobileBreadcrumbs = styled(Pane)`
  padding-top: ${rem(16)};
  padding-bottom: ${rem(16)};

  ${mediaQueryUp.tablet} {
    display: none;
  }
`

const StyledBusinessTravellerStickyBudgetBar = styled(BusinessTravellerStickyBudgetBar)`
  z-index: ${zIndex.floatingPanel};
`

const OfferPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const ObservableWrapper = styled.div`
  padding-top: 1px;
`

export const initialRooms = [generateRoomOccupants()]

interface Props extends RouteComponentProps<{ offerSlug: string, offerId: string }> {
  fetching: boolean;
  offer?: App.BedbankOffer;
  offerError?: any;
  regionCode: string;
  currency: string;
  promotionMinLos: number;
  isCalendarEnabled: boolean;
  defaults: Partial<OfferPageState>;
  headlessMode: boolean;
  traderInformation?: App.TraderInformation;
  defaultAirport?: App.Airport;
  isBedbankFlightBookingEnabled: boolean;
  relatedTravelItems: App.OfferState['relatedTravelItems'];
  propertyBestAlternateUrl?: string;
  lereLoadingError?: any;
  propertyPageOfferId?: string;
  alternativeOfferIds: App.AlternativeOffers,
  isSpoofed: boolean,
}

function BedbankOfferPage(props: Props) {
  const {
    fetching,
    match,
    offer,
    offerError,
    regionCode,
    currency,
    defaults,
    location,
    headlessMode,
    defaultAirport,
    isBedbankFlightBookingEnabled,
    relatedTravelItems,
    propertyBestAlternateUrl,
    traderInformation,
    propertyPageOfferId,
    alternativeOfferIds,
    promotionMinLos,
    isCalendarEnabled,
    isSpoofed,
  } = props

  const dispatch = useAppDispatch()
  const [showNavOfferContent, setShowNavOfferContent] = useState(false)
  const offerId = propertyPageOfferId || match.params.offerId
  const dataLoaded = useRef(false)

  const [state, stateDispatch, stateSnapshotRef] = useOfferPageReducer({
    ...defaults,
    airport: defaultAirport,
    bedbankOffer: offer,
  })

  /**
   * 1. go to a YMAL recommendation
   * 2. Refresh page (clears redux)
   * 3. Go back
   * 4. FETCH_BEDBANK_OFFER action fires, but reducer already computed its initialState where bedbankoffer was initially undefined
   * 5. Fetch done -> loading indicator disappears, component crashes
   *
   * This useEffect is a workaround that.
   */
  useEffect(() => {
    if (offer) {
      stateDispatch({ type: OfferPageActions.setBedBankOffer, bedbankOffer: offer })
    }
  }, [offer])

  const {
    activeFilter,
    checkInDate,
    checkOutDate,
    rooms,
    airport,
    duration,
    selectedBedbankRoomId,
  } = state

  useEffect(() => {
    if (offer) {
      // we use dataLoaded ref to prevent multiple analytics pushes
      fireEcommerceGTMEvent(accommodationOfferClicked(offer, currency))
      track('view-offer', viewOfferEvent())
      dataLoaded.current = true
    }
  }, [offer, currency])

  useEffect(() => {
    if (!showNavOfferContent && location.hash && location.hash !== urlHashDatePicker) {
      setShowNavOfferContent(true)
    }
  }, [location.hash])

  useEffect(() => {
    if (showNavOfferContent) {
      window.location.href = location.hash
    }
  }, [showNavOfferContent])

  useEffect(() => {
    if (offer) {
      dispatch(fetchAlternativeOffers(offer.id, 'bedbank', 'propertyPage'))
    }
  }, [offer?.id])

  useEffect(() => {
    if (!activeFilter && location.hash === urlHashDatePicker) {
      dispatch(replace({ ...location, hash: undefined }))
    }
  }, [activeFilter])

  useEffect(() => {
    if (location.hash === urlHashDatePicker) {
      stateDispatch({ type: OfferPageActions.toggleFilter, filter: 'datepicker' })
    }
  }, [location.hash])

  useEffect(() => {
    if (offer && ENABLED_OFFER_TYPES_RECENTLY_VIEWED.has(offer.type)) {
      dispatch(offerViewed(offer.id, offer.type))
    }
  }, [offer, dispatch])

  const occupancyNumber = useMemo(() => sumUpOccupancies(rooms), [rooms])
  const isoCheckinDate = checkInDate?.format(ISO_DATE_FORMAT)
  const isoCheckoutDate = checkOutDate?.format(ISO_DATE_FORMAT)
  const flightsEnabled = !!offer?.flights?.flightsEnabled && isBedbankFlightBookingEnabled && occupancyNumber < 10
  const flightPrice = useBedbankFlightPrice(offer, rooms, flightsEnabled, checkInDate, checkOutDate, airport?.code)

  useEffect(() => {
    if (offer) {
      dispatch(fetchRelatedTravelItems(offer, isoCheckinDate, isoCheckoutDate, rooms))
    }
  }, [offer, isoCheckinDate, isoCheckoutDate, rooms])

  // This one is used to load the section before the user gets to it
  const [navigableRef, navigableInView] = useInView({
    triggerOnce: true,
    rootMargin: '500px',
  })
  const setNavigableRef = useCallback(
    (node) => navigableRef(node),
    [navigableRef],
  )

  useEffect(() => {
    dispatch(fetchBedbankOfferById(offerId, { regionCode, flightOrigin: airport?.code }))
  }, [offerId])

  useEffect(() => {
    if (isEnabledForFeature(config.TRADER_INFORMATION_REGIONS, regionCode)) {
      dispatch(fetchTraderInformation(offerId, regionCode))
    }
  }, [offerId])

  useEffect(() => {
    if (!activeFilter) {
      if (offer && isoCheckinDate && isoCheckoutDate && rooms?.length) {
        dispatch(fetchRatesForBedbankOffer(offer, rooms, isoCheckinDate, isoCheckoutDate))
      }
    }
  }, [offerId, isoCheckinDate, isoCheckoutDate, rooms, offer?.id, activeFilter])

  const geoState = useContext(GeoContext)
  const hotLead = useSaveHotLead({
    offerId,
    offerType: 'bedbank_hotel',
    checkInDate,
    duration,
    checkOutDate,
    occupancy: rooms,
  })

  useEffect(() => {
    if (offer && hotLead?.checkIn && hotLead.checkOut) {
      Analytics.track('offer-page-hot-lead-event', offerPageHotLeadEvent(offer, hotLead, geoState))
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hotLead])

  useEffect(() => {
    if (offerId && config.BEDBANK_NEW_CALENDAR && duration && promotionMinLos <= duration) {
      dispatch(fetchCalendarForBedbankOffer(offerId, duration, selectedBedbankRoomId))
    }
  }, [offerId, rooms, duration, promotionMinLos, selectedBedbankRoomId])

  const hasPromotions = (offer?.promotions ?? []).length > 0

  useEffect(() => {
    if (offer?.flights.airportCode && flightsEnabled && airport && duration && promotionMinLos <= duration && config.BEDBANK_NEW_CALENDAR) {
      dispatch(fetchFlightCalendar({
        ...getPromotionDefaultPeriod(),
        origin: airport.code,
        destination: offer.flights.airportCode,
        nights: duration,
      }))
    }
  }, [offer, airport, flightsEnabled, promotionMinLos, duration])

  useEffect(() => {
    if (location.search) {
      const newSearch = removeSearchParamsFromURL(location.search)
      dispatch(replace({ ...location, search: newSearch }))
    }
  }, [])

  useEffect(() => {
    if (offer) {
      dispatch(bedbankOfferProductDetailView(offer))
      global.dataLayer?.push({ offerType: offer.type })
    }
  }, [offerId])

  const isBusinessUser = config.businessTraveller.currentAccountMode === 'business'
  const isLereEmbeddedCarouselEnabled = !!useAppSelector(state => getOptimizelyExperimentVariation(state, OptimizelyServerSideExperiments.lereOfferPageEmbeddedCarousel))

  // ------------- LERE sticky footer -------------------
  const ymalStickyFooterHideTrigger = useInView({ triggerOnce: false })
  const ymalStickyFooterShowTrigger = useInView({ triggerOnce: true })

  const canShowYmalFooter = ymalStickyFooterShowTrigger.inView && !ymalStickyFooterHideTrigger.inView
  const showRecommendations = !hasPromotions && !!offer && !isBusinessUser && !isSpoofed

  const recommendationFilters = useMemo<RecommendationsFilters>(() => ({
    propertyId: `bedbank:${offerId}`,
    searchNearby: true,
    checkIn: isoCheckinDate,
    checkOut: isoCheckoutDate,
    rooms,
  }), [offer, offerId, activeFilter, isoCheckinDate, isoCheckoutDate, rooms])
  // ------------- END of LERE sticky footer -------------------

  if (offerError) {
    if (offerError?.status == 404) {
      return <HttpStatus code={404}>
        <Error404Page />
      </HttpStatus>
    } else {
      <HttpStatus code={500}>
        return <Error500Page />
      </HttpStatus>
    }
  }

  if (fetching || !offer || !state.bedbankOffer) {
    return <LoadingIndicator data-testid="bedbank-offer-loading-indicator" />
  }

  if (match.params.offerSlug && (offer.slug !== match.params.offerSlug)) {
    return <RedirectWithStatus code={301} to={`/${regionCode.toLowerCase()}${offerPageURL(offer)}`} />
  }

  if (propertyBestAlternateUrl) {
    return <RedirectWithStatus code={301} to={propertyBestAlternateUrl} />
  }

  const metaDescription = `Book the best deal for ${offer.name}, ${offer.property.address.city} with Luxury Escapes today. The world's best escapes, handpicked by experts!`
  const breadCrumbItems = relatedTravelItems[offer?.id] || []

  let canonicalTag = ''

  if (config.ENABLE_ONE_PROPERTY_PAGE) {
    if (alternativeOfferIds?.leOfferDetails && alternativeOfferIds.leOfferDetails.length > 0) {
      if (alternativeOfferIds.leOfferDetails[0].type !== OFFER_TYPE_BED_BANK) {
        canonicalTag = `/property/${offer.slug}-le:${alternativeOfferIds.leOfferDetails[0].propertyId}`
      }
    }
    if (canonicalTag.length === 0) {
      canonicalTag = `/property/${offer.slug}-bedbank:${offer.id}`
    }
  } else {
    canonicalTag = `/partner/${offer.slug}/${offer.id}`
  }

  return <AnalyticsPageContext.Provider value={AnalyticsPage.offerPage} >
    <OfferPageStateProvider state={state} stateSnapshotRef={stateSnapshotRef} dispatch={stateDispatch}>
      <ImmersiveSaveButtonPortal>
        <BookmarkButton offer={offer} />
      </ImmersiveSaveButtonPortal>
      <HeadData
        title={`${offer.name}, ${offer.property.address.city} - ${config.title} ${regionCode}`}
        description={metaDescription}
        imageId={offer.images[0]?.id || undefined}
        canonical={canonicalTag}
      />
      <HotelStructuredData offer={offer} />
      <ErrorBoundary fallback={null}>
        <PromptCardSelector abandonedCart tripReengagement={false} stickyTop={60} />
      </ErrorBoundary>
      <StyledBusinessTravellerStickyBudgetBar
        checkInDate={checkInDate}
        checkOutDate={checkOutDate}
        offer={offer}
      />
      {config.businessTraveller.currentAccountMode !== 'business' && !headlessMode && <MobileBreadcrumbs>
        <LayoutContainer>
          <TopMobileRelatedTravelItems items={breadCrumbItems} />
        </LayoutContainer>
      </MobileBreadcrumbs>}
      <OfferPageWrapper className="OfferPage">
        <BedbankOfferContent
          offer={offer}
          isCalendarEnabled={isCalendarEnabled}
          checkinDate={checkInDate}
          checkoutDate={checkOutDate}
          duration={duration}
          rooms={rooms}
          activeFilter={activeFilter}
          flightsEnabled={flightsEnabled}
          flightPrice={flightPrice}
          recommendationFilters={recommendationFilters}
          showCustomersViewedAndBooked={showRecommendations && isLereEmbeddedCarouselEnabled}
          ymalStickyFooterHideTriggerRef={ymalStickyFooterHideTrigger.ref}
          ymalStickyFooterShowTriggerRef={ymalStickyFooterShowTrigger.ref}
          canShowYmalFooter={canShowYmalFooter}
        />
      </OfferPageWrapper>
      <ObservableWrapper ref={setNavigableRef}>
        <OfferTripPromotion offer={offer} />
        <Pane>
          <Spacing pb={24}>
            {(navigableInView || showNavOfferContent) && (
              <BedbankNavigableOfferContent
                offer={offer}
                traderInformation={traderInformation}
                hash={location.hash}
              />
            )}
          </Spacing>
        </Pane>
      </ObservableWrapper>
      <ErrorBoundary fallback={null}>
        {!isBusinessUser && <OfferRecommendations
        filters={recommendationFilters}
        offerId={offer.id}
        trackingDescription="Bedbank"
      />}
      </ErrorBoundary>
      <ObservableWrapper>
        {!headlessMode &&
          <BottomMobileRelatedTravelItems offer={offer} items={breadCrumbItems} title="Travel Destinations" />
      }
      </ObservableWrapper>
      {showRecommendations && !isLereEmbeddedCarouselEnabled && (
        <ErrorBoundary fallback={null}>
          <OfferYmalStickyFooter
            seedOffer={offer}
            filters={recommendationFilters}
            show={canShowYmalFooter}
            initialShowDelayMs={2000}
            hideImmediately={!!activeFilter}
            pageSource="Bedbank"
          />
        </ErrorBoundary>
      )}
    </OfferPageStateProvider>
  </AnalyticsPageContext.Provider>
}

const mapStateToProps = (state: App.State, ownProps: Partial<Props>) => {
  const offerId = ownProps.propertyPageOfferId || ownProps.match?.params?.offerId || ''
  const offer: App.BedbankOffer | undefined = state.offer.bedbankOffers[offerId]

  return {
    regionCode: state.geo.currentRegionCode,
    currency: state.geo.currentCurrency,
    fetching: !!state.offer.offersLoading[offerId] && !offer,
    offer,
    traderInformation: state.offer.traderInformation[offerId]?.data,
    offerError: state.offer.offerErrors[offerId],
    defaults: getInitialBedbankOfferPageState(state, offer),
    promotionMinLos: getPromotionMinLos({ bedbankOffer: offer }),
    isCalendarEnabled: isFlashCalendarEnabled({ bedbankOffer: offer }, state),
    headlessMode: state.config.headlessMode,
    defaultAirport: getDefaultAirport(state),
    isBedbankFlightBookingEnabled: isBedbankFlightBookingEnabled(state),
    propertyBestAlternateUrl: IS_SSR && getPropertyBestAlternateURL(state, offerId),
    relatedTravelItems: state.offer.relatedTravelItems,
    alternativeOfferIds: state.offer.alternativeOffersForProperty[`${offerId}propertyPage`],
    isSpoofed: state.auth.account.isSpoofed,
  }
}

export default withRouter(connect(mapStateToProps)(BedbankOfferPage))
